<template>
<div class="chapter">
<div class="inner_page">
<p class="break z"> </p>
<p class="chaphead m"><a href="#/html/06_toc#intro"><b>Introduction</b></a></p>
<p class="noind z"><span class="dropcap">T</span>his book has been written to consolidate an introduction of multiple subjects into one easy-to-read and carry source. It was my goal to make something which could be carried in your truck, car, or your back pocket so you could search through the table of contents and discover the equipment you would want and need in your journey to becoming prepared. You, Dear reader, will notice some subjects are not heavily explained, mostly the medical information. While I can do a lot of things, I am not a medical professional and I do not feel I should explain the best and worst ways to do those things.</p>
<p class="ind z">I have done my best to make this information straightforward to read, and I truly hope it helps to keep you and your family safe and secure in times of darkness and need. As I stated in my letter to you, this is just one piece of a larger picture. One thing I have found to be true over the years is everyone has a different idea on brand, style  and how something should, or shouldn’t work. This book should assist you in getting started and making your bags and stocking your vehicle, but I do encourage you to find  other sources of information and suggestions. We are all different in our needs as well as skill levels.</p>
<p class="break d"> </p>
<p class="center z">“<span class="underline">Frederick Douglass</span> taught that literacy is the path from slavery to freedom. There are many kinds of slavery and many kinds of freedom, but reading is still the path.” <br/> ― <b>Carl Sagan</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_intro.vue?7b1848fe